import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, ExtensionPriority, command, keyBinding, NamedShortcut, NodeExtension, ExtensionTag } from '@remirror/core';
import { ExtensionParagraphMessages } from '@remirror/messages';

var _dec, _dec2, _dec3, _dec4, _class, _class2;
var insertParagraphOptions = {
  icon: 'paragraph',
  label: _ref => {
    var t = _ref.t;
    return t(ExtensionParagraphMessages.INSERT_LABEL);
  },
  description: _ref2 => {
    var t = _ref2.t;
    return t(ExtensionParagraphMessages.INSERT_DESCRIPTION);
  }
};
var convertParagraphOptions = {
  icon: 'paragraph',
  label: _ref3 => {
    var t = _ref3.t;
    return t(ExtensionParagraphMessages.CONVERT_LABEL);
  },
  description: _ref4 => {
    var t = _ref4.t;
    return t(ExtensionParagraphMessages.CONVERT_DESCRIPTION);
  }
};
/**
 * The paragraph is one of the essential building blocks for a prosemirror
 * editor and by default it is provided to all editors.
 *
 * @core
 */

var ParagraphExtension = (_dec = extension({
  defaultPriority: ExtensionPriority.Medium
}), _dec2 = command(convertParagraphOptions), _dec3 = command(insertParagraphOptions), _dec4 = keyBinding({
  shortcut: NamedShortcut.Paragraph,
  command: 'convertParagraph'
}), _dec(_class = (_class2 = class ParagraphExtension extends NodeExtension {
  get name() {
    return 'paragraph';
  }

  createTags() {
    return [ExtensionTag.LastNodeCompatible, ExtensionTag.TextBlock, ExtensionTag.Block, ExtensionTag.FormattingNode];
  }

  createNodeSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({
      content: 'inline*',
      draggable: false
    }, override), {}, {
      attrs: _objectSpread({}, extra.defaults()),
      parseDOM: [{
        tag: 'p',
        getAttrs: node => _objectSpread({}, extra.parse(node))
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: node => {
        return ['p', extra.dom(node), 0];
      }
    });
  }
  /**
   * Convert the current node to a paragraph.
   */


  convertParagraph() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var attrs = options.attrs,
        selection = options.selection,
        preserveAttrs = options.preserveAttrs;
    return this.store.commands.setBlockNodeType.original(this.type, attrs, selection, preserveAttrs);
  }
  /**
   * Inserts a paragraph into the editor at the current selection.
   */


  insertParagraph(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var selection = options.selection,
        attrs = options.attrs;
    return this.store.commands.insertNode.original(this.type, {
      content,
      selection,
      attrs
    });
  }
  /**
   * Add the paragraph shortcut to the editor. This makes a paragraph into a
   */


  shortcut(props) {
    return this.convertParagraph()(props);
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "convertParagraph", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "convertParagraph"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "insertParagraph", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "insertParagraph"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shortcut", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "shortcut"), _class2.prototype)), _class2)) || _class);

export { ParagraphExtension };
